module.exports = __webpack_public_path__ + "img/slide_platica.5f29a5d2.jpeg";